export default "__VITE_ASSET__CGW90rpy__"